<div
   role="group"
   class="lcs-time-selector-button-group"
   aria-labelledby="lcs-time-picker-group-label lcs-time-picker-current-time"
>
   <span class="cdk-visually-hidden">
      <span id="lcs-time-picker-group-label">
         Choose a Time
      </span>
      <span id="lcs-time-picker-current-time"> Current value is {{ currentTime }} </span>
   </span>
   <lcs-spin-button
      name="Hour"
      decrementText="Previous Hour"
      incrementText="Next Hour"
      [value]="hours"
      [valueText]="hoursText"
      (increment)="onIncrementHours()"
      (decrement)="onDecrementHours()"
      (pageDown)="onPageDownHours()"
      (pageUp)="onPageUpHours()"
      (home)="onHomeHours()"
      (end)="onEndHours()"
      min="0"
      max="12"
      (keydownEvent)="onHourKeydown($event)"
   >
      {{ hoursDisplay }}
   </lcs-spin-button>
   <lcs-spin-button
      name="Minute"
      decrementText="Previous Minute"
      incrementText="Next Minute"
      [value]="minutes"
      [valueText]="minutesText"
      (increment)="onIncrementMinutes()"
      (decrement)="onDecrementMinutes()"
      (pageDown)="onPageDownMinutes()"
      (pageUp)="onPageUpMinutes()"
      (home)="onHomeMinutes()"
      (end)="onEndMinutes()"
      min="0"
      max="59"
      (keydownEvent)="onMinuteKeydown($event)"
   >
      {{ minutesText }}
   </lcs-spin-button>
   <lcs-spin-button
      name="Period"
      [decrementText]="opposingPeriod"
      [incrementText]="period"
      [value]="period"
      [valueText]="period"
      (increment)="onChangePeriod()"
      (decrement)="onChangePeriod()"
      (pageDown)="onChangePeriod()"
      (pageUp)="onChangePeriod()"
      (home)="onHomePeriod()"
      (end)="onEndPeriod()"
      min="AM"
      max="PM"
      (keydownEvent)="onPeriodKeydown($event)"
   >
      {{ period }}
   </lcs-spin-button>
</div>
